// Utils
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { normalizeHealthCard } from "Utils/Normalization";

export const formatPatientFormValues = (values) => ({
  ...values,
  healthCardNumber: normalizeHealthCard(values.healthCardNumber),
  dob: values.dob?.toFormat("yyyy-MM-dd"),
  primaryPhone:
    parsePhoneNumberFromString(values.primaryPhone, "CA")?.formatNational() ||
    "",
  secondaryPhone:
    parsePhoneNumberFromString(values.secondaryPhone, "CA")?.formatNational() ||
    "",
});
